var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.description))]),_c('p',[_vm._v(_vm._s(_vm.initValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }